import { render, staticRenderFns } from "./ChangePlan.vue?vue&type=template&id=2b4c3e04&scoped=true"
import script from "./ChangePlan.vue?vue&type=script&lang=js"
export * from "./ChangePlan.vue?vue&type=script&lang=js"
import style0 from "./ChangePlan.vue?vue&type=style&index=0&id=2b4c3e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c3e04",
  null
  
)

export default component.exports